import { visuallyHidden } from "@outschool/backpack";
import { Child } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import {
  SearchItem,
  SearchSuggestionsMenu
} from "@outschool/ui-components-website";
import {
  Container,
  useComponentTrackingContext
} from "@outschool/ui-legacy-component-library";
import React, { useEffect, useRef, useState } from "react";

import { useActiveLearnerSearchFilters } from "../../../hooks/useActiveLearnerSearchFilters";
import { useSearchFilters } from "../../../lib/useSearchFilters";
import { useSearchByLearner } from "../../../providers/SearchByLearnerProvider";
import LearnerFilterButton from "../LearnerFilterButton";
import useSearchWithSuggestions, {
  queryFromSearchItem
} from "../useSearchWithSuggestions";
import SearchForm from "./SearchForm";

export default function MobileSearch({}: {}) {
  const { t } = useTranslation(
    "client\\components\\search\\mobile\\MobileSearch"
  );

  const track = useComponentTrackingContext();

  const { filters: searchFilters, setFilters: setSearchFilters } =
    useSearchFilters();
  const [hasEditedSearchField, setHasEditedSearchField] = useState(false);

  const getLearnerSearchFilters = useActiveLearnerSearchFilters();
  const { showLearnerFilter, learner, setLearner } = useSearchByLearner();

  const handleLearnerChange = (learner: Child | null) => {
    const learnerFilters = getLearnerSearchFilters(learner);
    setSearchFilters?.("SearchByLearner", learnerFilters);
    setLearner(learner);
  };

  const {
    getComboboxProps,
    getLabelProps,
    getInputProps,
    getMenuProps,
    getItemProps,
    inputValue,
    setInputValue,
    onInputFocus,
    loadingSuggestions,
    suggestionsOpen,
    searchSuggestions,
    suggestionsHighlightedIndex,
    closeMenu,
    onUserSubmit
  } = useSearchWithSuggestions({
    onSearchFieldChange: () => setHasEditedSearchField(true),
    onSearchFieldCommit: item => {
      // @ts-ignore TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      setSearchFilters("Query", queryFromSearchItem(item, searchFilters));
      setHasEditedSearchField(false);
      onUserSubmit(item);
      if (iconRef.current) {
        iconRef.current.focus();
      }
    }
  });

  useEffect(() => {
    // @ts-ignore TS(2532): Object is possibly 'undefined'.
    setInputValue(searchFilters.q || searchFilters.userName || null);
    // @ts-ignore TS(2532): Object is possibly 'undefined'.
  }, [setInputValue, searchFilters.q, searchFilters.userName]);

  // @ts-ignore TS(2532): Object is possibly 'undefined'.
  const isTeacherSearch = !!searchFilters.userUid && !hasEditedSearchField;
  const iconRef = useRef<HTMLBodyElement>();

  return (
    <Container
      sx={{
        display: "flex",
        paddingY: "16px",
        flexDirection: "row",
        position: "relative",
        "* > input": {
          fontWeight: isTeacherSearch ? 500 : "unset"
        }
      }}
      {...getComboboxProps()}
    >
      <span style={visuallyHidden} {...getLabelProps()}>
        {t("Search for classes:")}
      </span>
      <SearchForm
        query={inputValue}
        setQuery={setInputValue}
        filters={searchFilters}
        onInputFocus={onInputFocus}
        getInputProps={getInputProps}
        onSubmit={query => {
          if (suggestionsOpen) {
            closeMenu();
          }

          const searchItem: SearchItem = {
            // eslint-disable-next-line i18next/no-literal-string
            type: "keyword",
            name: query || undefined,
            uid: ""
          };

          // @ts-ignore TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
          setSearchFilters(
            "Query",
            queryFromSearchItem(
              searchItem,
              // @ts-ignore TS(2345): Argument of type 'ExtendedSearchFiltersType | unde... Remove this comment to see the full error message
              searchFilters
            )
          );

          onUserSubmit(searchItem);
        }}
        spellCheck={!isTeacherSearch}
        iconRef={iconRef}
        leftComponent={
          showLearnerFilter ? (
            <LearnerFilterButton
              value={learner}
              onChange={handleLearnerChange}
            />
          ) : null
        }
      />
      <SearchSuggestionsMenu
        getMenuProps={getMenuProps}
        isOpen={suggestionsOpen}
        searchSuggestions={searchSuggestions}
        loadingSuggestions={loadingSuggestions}
        highlightedIndex={suggestionsHighlightedIndex}
        getItemProps={getItemProps}
        keyword={inputValue}
        menuStyle={{
          top: "68px",
          minWidth: 291,
          width: "100%"
        }}
        track={track}
      />
    </Container>
  );
}
